import React, { Component, Fragment } from 'react'
import AsyncSelect from 'react-select/lib/Async'
import { StyledInput } from './styled-input.style'
import Browser from '../../../services/Browser'
import { isMobile } from '../../../helpers/window.helper'
import scrollIntoView from 'scroll-into-view-if-needed'

export class LightSelectSearchBarAsync extends Component {
	constructor(props) {
		super(props)
	}

	render() {
		const {
			value,
			onChange,
			loadOptions,
			defaultOptions,
			placeholder,
			noOptionsMessage,
			disabled,
			handleBlur,
			defaultInputValue,
			maxMenuHeight,
			cache,
			isClearable,
			shadow,
			noBorder,
			styles,
		} = this.props
		const isIE = Browser.isIE()
		return (
			<StyledInput shadow={shadow} noBorder={noBorder}>
				<AsyncSelect
					value={value}
					defaultOptions={defaultOptions}
					loadOptions={loadOptions}
					cache={cache}
					isClearable={isClearable}
					defaultInputValue={defaultInputValue}
					onBlur={handleBlur}
					onChange={onChange}
					isDisabled={disabled}
					styles={styles}
					maxMenuHeight={maxMenuHeight || maxMenuHeight}
					isSearchable={true}
					className={'select'}
					style={{ zIndex: 10 }}
					backspaceRemovesValue={true}
					loadingMessage={() => 'Carregando ...'}
					menuPosition={isIE ? 'fixed' : 'absolute'}
					menuPortalTarget={document.body}
					placeholder={placeholder || 'Selecione...'}
					noOptionsMessage={() => (
						<div style={{ fontSize: '16px', cursor: 'default' }}>
							{noOptionsMessage || 'Nenhuma opção para pesquisa'}
						</div>
					)}
				/>
			</StyledInput>
		)
	}
}
